import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BookingCTA } from '../components/BookingCTA';
export function TestimonialsPage() {
  return <>
      <PageBanner title="Client Love" subtitle="Hear what our beautiful clients have to say about their Beni's African Hair Braiding experience." backgroundImage="https://cdn.magicpatterns.com/uploads/st4oeS41uakBMn5Py2Y32u/istockphoto-1333647263-612x612.webp" data-id="element-368" />
      <TestimonialsSection data-id="element-369" />
      <BookingCTA data-id="element-370" />
    </>;
}